/* Parallax Images
============================== */
$(window).on("load resize scroll", function() {
  $(".parallax-section").each(function() {
  var windowTop = $(window).scrollTop();
  var elementTop = $(this).offset().top - 100;
  var topPosition = (windowTop - elementTop) * .4;
    $(this)
      .find(".bg-move")
      .css({ top: -topPosition });
  });
  
  $(".bg-static").each(function() {
  var windowTop2 = $(window).scrollTop();
  var elementTop2 = $(this).offset().top;
  var topPosition2 = (windowTop2 - elementTop2) * .01;
    $(this)
      .find(".bg-move2")
      .css({ top: -topPosition2 });
  });
});

